import React from "react";
import './Home.css'


const Home = () => {
    return (
        <>
            <div className="nine">
                <h1>Practice On React JS
                    <span>Basic React</span>
                    <span>Hooks</span>
                    <span>API</span>
                    <span>Calculator</span>
                    <span>Todo List</span>
                    <span>Digital Watch</span>
                    <span>Timer</span>
                </h1>
            </div>
        </>
    );
}

export default Home